import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Componente che resetta lo scroll alla posizione superiore quando si cambia pagina
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on page navigation
    window.scrollTo(0, 0);
    
    // Reset body overflow to ensure scrolling works after navigation
    document.body.style.overflow = '';
  }, [pathname]);

  return null;
};

export default ScrollToTop; 